import type { Axios } from "axios";

export const createStudioSession = async (
  c: Axios,
  practiceId: string,
  file: File,
  templateId?: string | null,
) => {
  const { search } = window.location;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("practice_id", practiceId);
  if (templateId) {
    formData.append("template_id", templateId);
  }
  const response = await c.post<StudioSessionMessage>(
    `/studio/sessions${search}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data;
};

export const runStudioExtraction = (
  c: Axios,
  sessionId: string,
  promptText: string | null,
) =>
  c
    .post<StudioSessionMessage>(`/studio/sessions/${sessionId}/extract`, {
      promptText,
    })
    .then((r) => r.data);

export const updateStudioMapping = (
  c: Axios,
  sessionId: string,
  draftMapping: StudioDraftMapping,
) =>
  c
    .patch<StudioSessionMessage>(`/studio/sessions/${sessionId}/mapping`, {
      draftMapping,
    })
    .then((r) => r.data);

export const saveStudioTemplate = (
  c: Axios,
  sessionId: string,
  body: StudioSaveTemplateRequest,
) =>
  c
    .post<StudioTemplateMessage>(`/studio/sessions/${sessionId}/save`, body)
    .then((r) => r.data);

export const listStudioTemplates = (c: Axios, signal?: AbortSignal) =>
  c
    .get<StudioTemplateMessage[]>("/studio/templates", { signal })
    .then((r) => r.data);

export const getStudioTemplateDetails = (
  c: Axios,
  templateId: string,
  signal?: AbortSignal,
) =>
  c
    .get<StudioTemplateDetailsMessage>(
      `/studio/templates/${templateId}/details`,
      { signal },
    )
    .then((r) => r.data);

export const materializeStudioSession = (c: Axios, sessionId: string) =>
  c
    .post<StudioMaterializeResult>(`/studio/sessions/${sessionId}/materialize`)
    .then((r) => r.data);

export const listStudioFieldDefinitions = (c: Axios, signal?: AbortSignal) =>
  c
    .get<StudioFieldDefinitionsMessage>("/studio/field-definitions", {
      signal,
    })
    .then((r) => r.data);

export const fetchStudioDocumentBlob = async (
  c: Axios,
  documentPath: string,
) => {
  const response = await c.get("/documents/", {
    params: { d: documentPath },
    responseType: "blob",
  });
  return response.data as Blob;
};
